import { render, staticRenderFns } from "./Volunteergiftslist.vue?vue&type=template&id=3691e670&scoped=true"
import script from "./Volunteergiftslist.vue?vue&type=script&lang=js"
export * from "./Volunteergiftslist.vue?vue&type=script&lang=js"
import style0 from "./Volunteergiftslist.vue?vue&type=style&index=0&id=3691e670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3691e670",
  null
  
)

export default component.exports